import { SignalResponse } from '../../api/types';

export type SignalGroupKey =
    | 'ar'
    | 'ap'
    | 'cash'
    | 'margin'
    | 'data';

export function getSignalGroupKey(signal: Pick<SignalResponse, 'type' | 'title' | 'details' | 'metadata'>): SignalGroupKey {
    const metadata = signal.metadata || {};
    const rawType = String(signal.type || '').trim().toLowerCase();
    const sourceSystem = String(metadata.source_system || '').trim().toLowerCase();
    const detectorId = String(metadata.detector_id || '').trim().toLowerCase();
    const text = `${signal.title || ''} ${signal.details || ''}`.toLowerCase();

    if (sourceSystem === 'ar' || rawType === 'ar' || detectorId.startsWith('ar_signal:')) {
        return 'ar';
    }

    if (
        sourceSystem === 'ap'
        || sourceSystem === 'ap_pipeline'
        || rawType === 'ap'
        || rawType === 'bill'
        || detectorId.startsWith('signal_rule:ap_')
        || detectorId === 'signal_rule:duplicate_bill_candidate'
        || detectorId === 'signal_rule:payment_can_be_delayed'
        || detectorId === 'signal_rule:working_capital_squeeze'
        || detectorId === 'signal_rule:collections_below_obligations'
        || text.includes('working capital')
        || text.includes('vendor concentration')
        || text.includes('overdue payable')
        || text.includes('bills due')
        || text.includes('payables')
    ) {
        return 'ap';
    }

    if (
        rawType === 'invoice'
        || text.includes('invoice overdue')
        || text.includes('expected receipt')
        || text.includes('collections missed')
        || text.includes('customer')
    ) {
        return 'ar';
    }

    if (rawType === 'margin' || text.includes('gross margin') || text.includes('cogs')) {
        return 'margin';
    }

    if (
        text.includes('uncategorized')
        || text.includes('stale')
        || text.includes('missing sync')
        || text.includes('review')
        || detectorId.includes('data')
    ) {
        return 'data';
    }

    return 'cash';
}

export function getSignalGroupLabel(signal: Pick<SignalResponse, 'type' | 'title' | 'details' | 'metadata'>): string {
    const key = getSignalGroupKey(signal);
    switch (key) {
        case 'ar':
            return 'AR';
        case 'ap':
            return 'AP';
        case 'cash':
            return 'Cash';
        case 'margin':
            return 'Margin';
        case 'data':
            return 'Data';
        default:
            return 'Cash';
    }
}
